import React, { useEffect, useState } from 'react'
import { tagContext } from './context'
import { useDispatch, useSelector } from 'react-redux'
import { AlertError, Loader } from '../../../components'
import { fetchTags } from '../slice'

const TagProvider = ({ children }) => {
  const dispatch = useDispatch()
  const language = useSelector(state => state.system.language)
  const status = useSelector(state => state.tag.status)
  const error = useSelector(state => state.tag.error)
  const [errorMessage, setErrorMessage] = useState(null)
  const tags = useSelector(state => state.tag.data)
  const [tagOptions, setTagOptions] = useState([])

  useEffect(() => {
    if(status === 'idle'){
      dispatch(fetchTags())
    }
  }, [status, dispatch])

  useEffect(() => {
    if(error) setErrorMessage(error)
  }, [error])

  const formatter = React.useCallback(
    (data) => ({value: data.id, label: data.name[language.name]}),
    [language],
  );

  useEffect(() => {
    if(status === 'succeeded'){
      setTagOptions(tags.map(a => formatter(a)))
    }
  }, [status, language, tags, formatter])

  return (
    <tagContext.Provider value={{
      tags,
      tagOptions
    }}>
      {
        status === 'idle' &&
        <div className="text-center py-5 text-sm">
          Some data need to be fetched. <span className="link cursor-pointer" onClick={() => dispatch(fetchTags())}>Fetch</span>
        </div>
      }
      {
        status === 'loading' &&
        <div className="text-center py-5 text-sm">
          <Loader />
        </div>
      }
      {
        status === 'failed' &&
        <div className="text-center py-5 text-sm">
          <div className="mb-4">
            <p>Some data failed to be fetched.</p>
            <div>
              <span className="link cursor-pointer mr-4" onClick={() => dispatch(fetchTags())}>
                Retry
              </span>
            </div>
          </div>
          {
            errorMessage !== null &&
            <AlertError message={error} onClose={() => setErrorMessage(null)}/>
          }
        </div>
      }
      {
        status === 'succeeded' &&
        children
      }
    </tagContext.Provider>
  );
};

export { TagProvider }
